import React from "react";
import { ApolloLink } from '@apollo/client/link/core';
import Button from '@mui/material/Button';

import i18next from '../../src/i18n/config';
import Snackbar from "../../src/services/snackbar";

let CURRENT_APP_VERSION = null;

const t = (key) => i18next.t(`apollo-version-tracker.${key}`);

const versionTrackerLink = new ApolloLink((operation, forward) => {
  return forward(operation).map(response => {
    const context = operation.getContext();
    const newVersion = context.response.headers.get("X-React-App-SHA");

    if (CURRENT_APP_VERSION && newVersion && CURRENT_APP_VERSION !== newVersion) {
      Snackbar.info(
        t("newVersion"),
        {
          action: key => <Button onClick={() => window.location.reload()} color="inherit" textSizeSmall sizeSmall>{t("refresh")}</Button>,
          persist: true,
        }
      )
    }

    CURRENT_APP_VERSION = newVersion;
    return response;
  });
});

export default versionTrackerLink;
